export const translations = {
  es: {
    // Header
    bridge: 'Bridge',
    history: 'Historial',
    connect: 'Conectar',
    adminPanel: 'Panel Admin',
    p2p: 'P2P',
    p2pOrders: 'Mis órdenes',
    p2pTrades: 'Mis trades',

    // Bridge Form
    network: 'Red',
    amount: 'Cantidad',
    enterAmount: 'Ingresa la cantidad',
    balance: 'Balance',
    max: 'MAX',
    min: 'Min',
    fee: 'Comisión',
    youWillReceive: 'Recibirás',
    destinationAddress: 'Dirección destino (BSC)',
    destinationAddressPlaceholder: 'Ingresa tu dirección BSC',
    useConnectedWallet: 'Usar wallet conectada',

    // Buttons
    approve: 'Aprobar W2USDT',
    approving: 'Aprobando...',
    bridgeAction: 'Bridge',
    bridging: 'Procesando Bridge...',
    insufficientBalance: 'Saldo insuficiente',
    connectWallet: 'Conectar Wallet',
    enterValidAmount: 'Ingresa una cantidad válida',
    amountBelowMin: 'Cantidad por debajo del mínimo',
    amountAboveMax: 'Cantidad por encima del máximo',

    // Modal
    accept: 'Aceptar',

    // Status
    pending: 'Pendiente',
    pendingApproval: 'Tu solicitud ha sido registrada y está pendiente de aprobación por el administrador.',
    approved: 'Aprobado',
    completed: 'Completado',
    rejected: 'Rechazado',
    cancelled: 'Cancelado',
    failed: 'Fallido',

    // History
    myBridges: 'Mis Bridges',
    noBridges: 'No tienes bridges aún',
    date: 'Fecha',
    status: 'Estado',
    sent: 'Enviado',
    received: 'Recibido',
    txHash: 'TX Hash',
    cancel: 'Cancelar',
    cancelling: 'Cancelando...',
    cancelBridge: 'Cancelar Bridge',
    confirmCancel: '¿Estás seguro de que quieres cancelar este bridge?',

    // Misc
    loading: 'Cargando...',
    error: 'Error',
    success: 'Success',
    viewOnExplorer: 'Ver en explorador',
    copied: 'Copiado',
    paused: 'El bridge está pausado',

    // History Page
    connectWalletHistory: 'Conecta tu Wallet',
    connectWalletHistoryDesc: 'Conecta tu wallet para ver tu historial.',
    goToBridge: 'Ir al Bridge',
    noRequestsYet: 'Sin solicitudes',
    noRequestsYetDesc: 'Aún no has realizado ningún bridge.',
    firstBridge: 'Realizar tu primer Bridge',
    queuePosition: 'Cola',
    txUni2: 'TX Uni2',
    txBsc: 'TX BSC',

    // Landing Page
    heroTitle: 'El Dólar Digital de',
    heroTitleHighlight: 'Uni2',
    heroSubtitle: 'W2USDT es el token wrapped de USDT en la red Uni2. Estabilidad, utilidad y el respaldo de una comunidad en crecimiento.',
    startBridge: 'Usar Bridge',
    learnMore: 'Descubrir Más',
    joinCommunity: 'Únete a la Comunidad',

    // What is W2USDT
    whatIsTitle: '¿Qué es',
    whatIsW2USDT: 'W2USDT',
    whatIsDesc: 'W2USDT es un token estable (wrapped USDT) desplegado en la red Uni2, diseñado para mantener paridad 1:1 con el dólar estadounidense. Representa la puerta de entrada al ecosistema Uni2 con la estabilidad que necesitas.',
    whatIsDesc2: 'A diferencia de otros tokens, W2USDT combina la estabilidad del dólar con las ventajas de la red Uni2: transacciones ultrarrápidas, costes mínimos y una comunidad activa que impulsa su adopción cada día.',

    // Features
    featuresTitle: '¿Por qué elegir',
    featuresTitleHighlight: 'W2USDT?',
    featureSecure: 'Estabilidad Garantizada',
    featureSecureDesc: 'Paridad 1:1 con USDT. Tu valor protegido frente a la volatilidad del mercado crypto.',
    featureFast: 'Transacciones Instantáneas',
    featureFastDesc: 'La red Uni2 permite transferencias en segundos con costes de gas prácticamente inexistentes.',
    featureLowFee: 'Utilidad Real',
    featureLowFeeDesc: 'Úsalo para pagos, trading, staking y participación en el ecosistema DeFi de Uni2.',
    featureSupport: 'Comunidad Activa',
    featureSupportDesc: 'Forma parte de una comunidad en crecimiento con soporte continuo y desarrollo constante.',

    // Ecosystem
    ecosystemTitle: 'Ecosistema',
    ecosystemTitleHighlight: 'Uni2',
    ecosystemDesc: 'W2USDT es el token de referencia dentro del ecosistema Uni2, una red blockchain de nueva generación diseñada para escalabilidad y eficiencia.',
    ecosystemFeature1: 'Red Uni2',
    ecosystemFeature1Desc: 'Blockchain EVM-compatible con confirmaciones rápidas y gas mínimo.',
    ecosystemFeature2: 'DeFi Nativo',
    ecosystemFeature2Desc: 'Acceso a exchanges descentralizados, pools de liquidez y yield farming.',
    ecosystemFeature3: 'Crecimiento Continuo',
    ecosystemFeature3Desc: 'Nuevos proyectos y utilidades se integran constantemente en el ecosistema.',

    // Bridge Section
    bridgeTitle: 'Necesitas',
    bridgeTitleHighlight: 'USDT en BSC?',
    bridgeDesc: 'Nuestro bridge te permite convertir W2USDT a USDT real en Binance Smart Chain cuando lo necesites. Proceso seguro, verificado y con comisiones competitivas.',
    bridgeFeature1: 'Conversión Segura',
    bridgeFeature2: 'Proceso Verificado',
    bridgeFeature3: 'Soporte Dedicado',
    bridgeButton: 'Ir al Bridge',

    // Community
    communityTitle: 'Únete a la',
    communityTitleHighlight: 'Comunidad',
    communityDesc: 'Miles de usuarios ya confían en W2USDT como su token estable de referencia en Uni2. Sé parte del futuro de las finanzas descentralizadas.',

    // CTA
    ctaTitle: 'El futuro es',
    ctaTitleHighlight: 'Estable',
    ctaDesc: 'Comienza a usar W2USDT hoy y descubre las ventajas de tener un dólar digital en la red más eficiente.',
    ctaButton: 'Explorar W2USDT',

    // Stats
    statVolume: 'Volumen Total',
    statTransactions: 'Transacciones',
    statUsers: 'Holders',
    statUptime: 'Estabilidad',
  },
  en: {
    // Header
    bridge: 'Bridge',
    history: 'History',
    connect: 'Connect',
    adminPanel: 'Admin Panel',
    p2p: 'P2P',
    p2pOrders: 'My orders',
    p2pTrades: 'My trades',

    // Bridge Form
    network: 'Network',
    amount: 'Amount',
    enterAmount: 'Enter amount',
    balance: 'Balance',
    max: 'MAX',
    min: 'Min',
    fee: 'Fee',
    youWillReceive: 'You will receive',
    destinationAddress: 'Destination address (BSC)',
    destinationAddressPlaceholder: 'Enter your BSC address',
    useConnectedWallet: 'Use connected wallet',

    // Buttons
    approve: 'Approve W2USDT',
    approving: 'Approving...',
    bridgeAction: 'Bridge',
    bridging: 'Processing Bridge...',
    insufficientBalance: 'Insufficient balance',
    connectWallet: 'Connect Wallet',
    enterValidAmount: 'Enter a valid amount',
    amountBelowMin: 'Amount below minimum',
    amountAboveMax: 'Amount above maximum',

    // Modal
    accept: 'Accept',

    // Status
    pending: 'Pending',
    pendingApproval: 'Your request has been registered and is pending approval by the administrator.',
    approved: 'Approved',
    completed: 'Completed',
    rejected: 'Rejected',
    cancelled: 'Cancelled',
    failed: 'Failed',

    // History
    myBridges: 'My Bridges',
    noBridges: 'You have no bridges yet',
    date: 'Date',
    status: 'Status',
    sent: 'Sent',
    received: 'Received',
    txHash: 'TX Hash',
    cancel: 'Cancel',
    cancelling: 'Cancelling...',
    cancelBridge: 'Cancel Bridge',
    confirmCancel: 'Are you sure you want to cancel this bridge?',

    // Misc
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    viewOnExplorer: 'View on explorer',
    copied: 'Copied',
    paused: 'Bridge is paused',

    // History Page
    connectWalletHistory: 'Connect your Wallet',
    connectWalletHistoryDesc: 'Connect your wallet to see your history.',
    goToBridge: 'Go to Bridge',
    noRequestsYet: 'No requests',
    noRequestsYetDesc: 'You have not made any bridge yet.',
    firstBridge: 'Make your first Bridge',
    queuePosition: 'Queue',
    txUni2: 'TX Uni2',
    txBsc: 'TX BSC',

    // Landing Page
    heroTitle: 'The Digital Dollar of',
    heroTitleHighlight: 'Uni2',
    heroSubtitle: 'W2USDT is the wrapped USDT token on the Uni2 network. Stability, utility, and the backing of a growing community.',
    startBridge: 'Use Bridge',
    learnMore: 'Discover More',
    joinCommunity: 'Join the Community',

    // What is W2USDT
    whatIsTitle: 'What is',
    whatIsW2USDT: 'W2USDT',
    whatIsDesc: 'W2USDT is a stable token (wrapped USDT) deployed on the Uni2 network, designed to maintain 1:1 parity with the US dollar. It represents the gateway to the Uni2 ecosystem with the stability you need.',
    whatIsDesc2: 'Unlike other tokens, W2USDT combines dollar stability with Uni2 network advantages: ultra-fast transactions, minimal costs, and an active community driving adoption every day.',

    // Features
    featuresTitle: 'Why choose',
    featuresTitleHighlight: 'W2USDT?',
    featureSecure: 'Guaranteed Stability',
    featureSecureDesc: '1:1 parity with USDT. Your value protected against crypto market volatility.',
    featureFast: 'Instant Transactions',
    featureFastDesc: 'Uni2 network enables transfers in seconds with virtually non-existent gas costs.',
    featureLowFee: 'Real Utility',
    featureLowFeeDesc: 'Use it for payments, trading, staking, and participation in the Uni2 DeFi ecosystem.',
    featureSupport: 'Active Community',
    featureSupportDesc: 'Be part of a growing community with continuous support and constant development.',

    // Ecosystem
    ecosystemTitle: 'Uni2',
    ecosystemTitleHighlight: 'Ecosystem',
    ecosystemDesc: 'W2USDT is the reference token within the Uni2 ecosystem, a next-generation blockchain network designed for scalability and efficiency.',
    ecosystemFeature1: 'Uni2 Network',
    ecosystemFeature1Desc: 'EVM-compatible blockchain with fast confirmations and minimal gas.',
    ecosystemFeature2: 'Native DeFi',
    ecosystemFeature2Desc: 'Access to decentralized exchanges, liquidity pools, and yield farming.',
    ecosystemFeature3: 'Continuous Growth',
    ecosystemFeature3Desc: 'New projects and utilities are constantly integrating into the ecosystem.',

    // Bridge Section
    bridgeTitle: 'Need',
    bridgeTitleHighlight: 'USDT on BSC?',
    bridgeDesc: 'Our bridge allows you to convert W2USDT to real USDT on Binance Smart Chain when you need it. Secure, verified process with competitive fees.',
    bridgeFeature1: 'Secure Conversion',
    bridgeFeature2: 'Verified Process',
    bridgeFeature3: 'Dedicated Support',
    bridgeButton: 'Go to Bridge',

    // Community
    communityTitle: 'Join the',
    communityTitleHighlight: 'Community',
    communityDesc: 'Thousands of users already trust W2USDT as their reference stable token on Uni2. Be part of the future of decentralized finance.',

    // CTA
    ctaTitle: 'The future is',
    ctaTitleHighlight: 'Stable',
    ctaDesc: 'Start using W2USDT today and discover the advantages of having a digital dollar on the most efficient network.',
    ctaButton: 'Explore W2USDT',

    // Stats
    statVolume: 'Total Volume',
    statTransactions: 'Transactions',
    statUsers: 'Holders',
    statUptime: 'Stability',
  },
} as const;

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations.es;
